var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 744.66 594.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-11,.cls-13,.cls-2,.cls-3{fill:none;stroke-linecap:round;}.cls-1,.cls-13,.cls-2{stroke:#000;}.cls-1,.cls-2,.cls-3{stroke-miterlimit:10;}.cls-1{stroke-width:4px;}.cls-13,.cls-2{stroke-width:2px;}.cls-3{stroke:#1f161e;}.cls-4{fill:#fbdc8e;}.cls-5{fill:#969696;}.cls-6{fill:#ab8de5;}.cls-7{fill:#78e5e1;}.cls-8{fill:#d8d8d8;}.cls-9{fill:#64ccc4;}.cls-10,.cls-12{fill:#fff;}.cls-11{stroke:#969696;stroke-width:0.82px;}.cls-11,.cls-13{stroke-linejoin:round;}.cls-12{font-size:7.3px;font-family:SofiaPro-Bold, Sofia Pro;font-weight:700;}.cls-14{fill:#1f161e;}.cls-15{fill:#55b79d;}.cls-16{fill:#f8cdba;}.cls-17{fill:#fa9e9f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "example-scene-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 332.04,
    cy: 476.96,
    rx: 63.11,
    ry: 13.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 332.04,
    y1: 476.96,
    x2: 296.59,
    y2: 587.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 332.04,
    y1: 476.96,
    x2: 367.49,
    y2: 587.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 308.23,
    y1: 551.48,
    x2: 347.75,
    y2: 526.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 316.17,
    y1: 526.14,
    x2: 355.7,
    y2: 551.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M394.15,356.86c-.16,4.92-.09,22.15-.9,29.52"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.46,
    y: 132.63,
    width: 12.66,
    height: 34.51,
    rx: 6.33,
    ry: 6.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.79,
    cy: 191.17,
    r: 12.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M609.37,342h6a2.39,2.39,0,0,0,2.38-2.38V302.74a2.35,2.35,0,0,0-.7-1.68l-7.58-7.58a2.37,2.37,0,0,0-1.68-.7H585.4a2.39,2.39,0,0,0-2.38,2.38v3.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.06,430c19,3.6,15.61,117-20.86,110.14C32.76,533.6,64.88,425.59,88.06,430Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4.64,444c15.12-8.56,78.41,71.08,49.46,87.46C26.75,547-13.77,454.44,4.64,444Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M81.69,594.92H43.51a6.25,6.25,0,0,1-6.21-5.56l-4.82-43.28a6.26,6.26,0,0,1,6.21-7H86.31a6.25,6.25,0,0,1,6.21,6.92l-4.61,43.28A6.26,6.26,0,0,1,81.69,594.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M98.79,385.84c14.47,4.2,3.38,91.73-24.33,83.67C48.3,461.91,81.18,380.72,98.79,385.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.65,455.48c10,8.62-30.68,74.56-49.9,58C54.6,497.91,110.44,445,122.65,455.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62.7,394.94c21.66,0,41.49,138.3,0,138.3C23.52,533.24,36.33,394.94,62.7,394.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 20.46,
    y: 529.72,
    width: 84.3,
    height: 15.48,
    rx: 4.05,
    ry: 4.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M599.29,298.72h-22a2.68,2.68,0,0,0-2.68,2.69v43.8a2.69,2.69,0,0,0,2.68,2.69h29.39a2.69,2.69,0,0,0,2.68-2.69v-36.4a2.68,2.68,0,0,0-.78-1.9l-7.4-7.4A2.68,2.68,0,0,0,599.29,298.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M609.37,307.76H601.9a1.5,1.5,0,0,1-1.5-1.5v-7.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M617.78,301.83h-7.47a1.52,1.52,0,0,1-1.51-1.51v-7.54"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 520.05,
    y: 248.65,
    width: 57.62,
    height: 22.9,
    rx: 3.03,
    ry: 3.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "548.85 287.25 555.79 266.23 541.91 266.23 548.85 287.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "535.1 254.75 529.28 264.82 540.91 264.82 535.1 254.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "562.61 264.82 568.43 254.75 556.79 254.75 562.61 264.82"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 548.85,
    cy: 259.79,
    r: 4.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 507.87,
    y: 200.12,
    width: 39.14,
    height: 25.76,
    rx: 2.65,
    ry: 2.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 509.1,
    y1: 200.93,
    x2: 527.44,
    y2: 213
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 547.01,
    y1: 200.12,
    x2: 527.44,
    y2: 213
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 547.01,
    cy: 200.12,
    r: 5.6
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(545.39 202.28)"
  }, "1"), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 596.2,
    y: 215.83,
    width: 148.46,
    height: 3.22,
    rx: 1.23,
    ry: 1.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 647.67,
    y: 151.89,
    width: 13.99,
    height: 63.94,
    rx: 2.56,
    ry: 2.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 661.66,
    y: 166.88,
    width: 7,
    height: 48.95,
    rx: 2.13,
    ry: 2.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 668.66,
    y: 166.88,
    width: 7,
    height: 48.95,
    rx: 2.06,
    ry: 2.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 684.21,
    y: 168.74,
    width: 7,
    height: 48.95,
    rx: 2.2,
    ry: 2.2,
    transform: "translate(-17.9 304.51) rotate(-24.66)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 654.66,
    cy: 195.74,
    r: 3.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 650.18,
    y: 201.99,
    width: 8.96,
    height: 1.88,
    rx: 0.94,
    ry: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 650.18,
    y: 206.8,
    width: 8.96,
    height: 1.88,
    rx: 0.94,
    ry: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 578.54,
    y: 303.24,
    width: 8.96,
    height: 1.88,
    rx: 0.94,
    ry: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 578.54,
    y: 307.76,
    width: 8.96,
    height: 1.88,
    rx: 0.94,
    ry: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 578.13,
    y: 315.49,
    width: 27.73,
    height: 1.88,
    rx: 0.94,
    ry: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 578.13,
    y: 319.93,
    width: 27.73,
    height: 1.88,
    rx: 0.94,
    ry: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 578.13,
    y: 324.37,
    width: 27.73,
    height: 1.88,
    rx: 0.94,
    ry: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 664.43,
    y: 173.54,
    width: 1.46,
    height: 35.62,
    rx: 0.73,
    ry: 0.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 626.43,
    y: 217.44,
    width: 11.24,
    height: 4.98,
    rx: 2.49,
    ry: 2.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 703.19,
    y: 217.44,
    width: 11.24,
    height: 4.98,
    rx: 2.49,
    ry: 2.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 427.14,
    y: 222.31,
    width: 60.51,
    height: 41.81,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 439.66,
    y: 229.04,
    width: 9.1,
    height: 28.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 452.85,
    y: 247.9,
    width: 9.1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 466.03,
    y: 239.9,
    width: 9.1,
    height: 17.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M184.79,152.88a38.29,38.29,0,0,0-38.3,38.29h76.6A38.29,38.29,0,0,0,184.79,152.88Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 184.79,
    y1: 139.92,
    x2: 184.79,
    y2: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M485.19,574.68c0,2.37-1.39,17.32,1.38,18.7s33.22,2.22,34.6.83,2.21-4.29,1-5.12-13-3.18-14.6-4.29-3.81-7-3-10.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M394.15,379.25l17.14-6.15c-.74-31.27-8.05-101.14-18.43-111.53-2.44-2.43-50.7-6.67-59.31-6.67-51.38,0-66.62,5.86-70.49,9.74-12,12-15.74,67.6-15.74,87.07s55,29.57,55,29.57l64.47,4.43s14.14,1.46,26.37,2.18C393.43,384.14,394.15,379.25,394.15,379.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M445.22,397.38c4.69-1.39,51.33-9,61.49,1s42.14,153.37,42.14,156.67H523.1l-34.76-74.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M275.41,384.63c-1.17,5.85-8.2,12.13-8.2,44,0,44.07,36.1,45,49.06,45,40.38,0,105.71-12,110.12-14.2,2.93,4.9,56.86,115,57.11,117.46h24.83s-15.39-164.72-43.16-183.4C456.15,387.49,296.12,381.07,275.41,384.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M420.81,352.41c-6.52,0-11.9,1.55-26.66,4.45l-.77,28.24c14-5.64,17.25-13.48,21.31-13.48,10.14,0,15.44,5.23,21.43,5.23,4.18,0,11.7-3.28,11.7-7.74C447.82,359.77,428.89,352.41,420.81,352.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M524.56,553.07c0,2.38-1.39,17.32,1.38,18.71s33.22,2.21,34.6.83,2.21-4.29,1-5.12-13-3.19-14.6-4.3-3.81-7-3-10.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M342.64,261.55c0,3.77-21.89,3.88-21.89,0V230.89h21.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M335.51,241c-2,0-14.76,5.64-14.76,8.79V233.15C323.93,233.15,335.51,241,335.51,241Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 339.74,
    cy: 215.8,
    r: 26.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M367.09,195c-3.28,5.21-10.14,7.6-17.57,7.6-6.33,0-15.55-1.84-22.11,1.9-3.55,2-7.62,6.55-8.44,15.66,0,1.56-1.77,7.61-1.77,9.56,0,1.33-1.5,2.2-4,2.2-1.29,0-3.84-2.09-3.84-5.28,0-3.69,1.47-5,1.47-8.13S307,212.37,307,203.67c0-12.53,8-20.25,13.66-20.25,5.16,0,6.78,1.2,7.43,1.71,0-11.39,15-16.59,20.95-16.59,6.8,0,10,2.79,10,6.34,0,5.66-2.7,10.47-4.07,11.55a16.8,16.8,0,0,1,11.3-4.31c7.79,0,10.41,5.12,10.41,8.62,0,7.61-9.13,14.66-12.53,14.66a36.33,36.33,0,0,0-3-5.19"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 319.79,
    cy: 219.3,
    r: 5.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 366.5,
    cy: 218.38,
    rx: 4.38,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 338.95,
    cy: 218.38,
    rx: 4.38,
    ry: 2.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M355.8,213.65c.82,1.17,5,6.08.59,8.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M347.56,227.45c-1.32,0-3.35-1.64-4.42-3.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M382.5,298.62c2,4.25,11.65,45.25,11.65,58.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M247.32,348.41c0,46.09.43,59.46,18.93,59.46,42.64,0,107.1-35,118.59-35,10.15,0,15.45,5.24,21.44,5.24,4.17,0,11.69-3.29,11.69-7.74,0-9.35-18.93-16.71-27-16.71-18.17,0-90.68,17.52-92.45,17.52s-4.75-.77-4.75-3.75c0-5.41,3.54-17.91,4-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M308.42,308.21c-1.22,3.51-10.73,39.78-11.83,44.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 643.68,
    y: 384.29,
    width: 10.24,
    height: 211.6,
    rx: 5.12,
    ry: 5.12,
    transform: "translate(1400.9 799.09) rotate(165.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 582.06,
    y: 384.29,
    width: 10.24,
    height: 211.6,
    rx: 5.12,
    ry: 5.12,
    transform: "translate(143.93 -133.2) rotate(14.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 511.42,
    y: 384.29,
    width: 10.24,
    height: 211.6,
    rx: 5.12,
    ry: 5.12,
    transform: "translate(141.6 -115.24) rotate(14.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 572.16,
    y: 384.29,
    width: 10.24,
    height: 211.6,
    rx: 5.12,
    ry: 5.12,
    transform: "matrix(-0.97, 0.25, -0.25, -0.97, 1260.2, 817.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223,
    y: 384.29,
    width: 10.24,
    height: 211.6,
    rx: 5.12,
    ry: 5.12,
    transform: "translate(132.12 -41.9) rotate(14.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 283.75,
    y: 384.29,
    width: 10.24,
    height: 211.6,
    rx: 5.12,
    ry: 5.12,
    transform: "translate(692.86 890.62) rotate(165.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 149.57,
    y: 378.14,
    width: 504.23,
    height: 15.15,
    rx: 4.53,
    ry: 4.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 149.82,
    y: 384.29,
    width: 10.24,
    height: 211.6,
    rx: 5.12,
    ry: 5.12,
    transform: "translate(129.72 -23.29) rotate(14.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 210.56,
    y: 384.29,
    width: 10.24,
    height: 211.6,
    rx: 5.12,
    ry: 5.12,
    transform: "translate(548.9 909.23) rotate(165.27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.28,378.14H427.77l16.76-57.64a6.73,6.73,0,0,1,6.48-4.79h78.5a6.62,6.62,0,0,1,6.48,8.41Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 485.38,
    cy: 346.92,
    r: 5.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.85,
    y: 374.09,
    width: 64.91,
    height: 4.05
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9dc262ad79335c125a30ccfd9d10985d.svg";
export { ForwardRef as ReactComponent };